import React from 'react';
import PropTypes from 'prop-types';
// Import Translations
import { homeEn } from '../../../i18n/home';
// Import Global Components
import Heading from '../../../components/Heading';
import Text from '../../../components/Text';
// Import Local Components
import ModifyStatusButton from './ModifyStatusButton';
import ViewPinButton from './ViewPinButton';
// Import Common Utils
import { isPinBlocked } from '../../../utils/cardStatus';
import { UnblockPinButton } from '../../../components/PinUnblock';
import { ReplaceCardButton } from '../../../components/CardReplacement';
// Import Component Styles
import { HeaderWrapper, HeaderButtons, WelcomeText } from '../styles';

const HomeHeader = ({
  data: {
    lastFourDigits,
    user: { firstName, lastName },
    accountId,
    cardStatus,
    account,
  },
  pinUnblock,
  cardReplacement,
  ...props
}) => (
  <HeaderWrapper>
    <WelcomeText>
      <Heading
        page="home"
        heading={homeEn['home-heading']}
        values={{
          name: `${firstName} ${lastName}`,
        }}
      />
      {lastFourDigits && (
        <Text
          page="home"
          textFor="card-number"
          text={homeEn['home-card-number-text']}
          values={{
            number: lastFourDigits,
          }}
        />
      )}
    </WelcomeText>
    {lastFourDigits && (
      <HeaderButtons>
        <ViewPinButton currentAccount={account} />
        {pinUnblock && (
          <UnblockPinButton state={pinUnblock.state} onClick={pinUnblock.open} size="large" />
        )}
        {/* Suspend/unsuspend cannot lift a PIN block; Unlock PIN is the way back. */}
        {!isPinBlocked(cardStatus) && (
          <ModifyStatusButton
            lastFourDigits={lastFourDigits}
            accountId={accountId}
            cardStatus={cardStatus}
            {...props}
          />
        )}
        {cardReplacement && (
          <ReplaceCardButton
            state={cardReplacement.state}
            onClick={cardReplacement.open}
            size="large"
          />
        )}
      </HeaderButtons>
    )}
  </HeaderWrapper>
);

HomeHeader.propTypes = {
  data: PropTypes.shape({
    cardStatus: PropTypes.string.isRequired,
    accountId: PropTypes.number.isRequired,
    lastFourDigits: PropTypes.number,
    user: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
    account: PropTypes.shape({
      id: PropTypes.number.isRequired,
      cards: PropTypes.array.isRequired, //eslint-disable-line
    }).isRequired,
  }).isRequired,
  setAlert: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func,
  pinUnblock: PropTypes.shape({
    state: PropTypes.string.isRequired,
    open: PropTypes.func.isRequired,
  }),
  cardReplacement: PropTypes.shape({
    state: PropTypes.string.isRequired,
    open: PropTypes.func.isRequired,
  }),
};

HomeHeader.defaultProps = {
  onStatusChange: () => {},
  pinUnblock: null,
  cardReplacement: null,
};

export default HomeHeader;
